import axiosClient from './axiosClient';

export const aiMenuDesignApi = {
  generate(menuId, payload = {}) {
    return axiosClient.post(
      `/menus/${menuId}/ai-designs/generate`,
      payload,
    );
  },

  getGeneration(menuId, generationId) {
    return axiosClient.get(
      `/menus/${menuId}/ai-designs/${generationId}`,
    );
  },

  accept(menuId, generationId) {
    return axiosClient.post(
      `/menus/${menuId}/ai-designs/${generationId}/accept`,
    );
  },

  reject(menuId, generationId) {
    return axiosClient.post(
      `/menus/${menuId}/ai-designs/${generationId}/reject`,
    );
  },
};

export default aiMenuDesignApi;